import React from 'react';
import {ICONS, Slider} from "../../../components";
import OTPReceiverForm from "../../LoginPage/OTPReceiverForm";
import {TicketPrint} from "../../../api";
import OTPSubmitForm from "../../LoginPage/OTPSubmitForm";
import {TicketService} from "../../../services";
import {useDispatch} from "react-redux";
import {showSuccessToast} from "../../../state/toasts";
import * as ReactBootstrap from "react-bootstrap";

export type DeliveryOTPProps= {
    ticket: TicketPrint;
    onOTPVerificationSuccess: (ticket:TicketPrint) => void;
};

export default function DeliveryOTP({ticket,onOTPVerificationSuccess}: DeliveryOTPProps) {
    const [step, setStep] = React.useState(0);
    const [otp_uuid, setOTP_UUID] = React.useState("");
    const dispatch = useDispatch()
    const verifyOTPHandler = (values) => {
    values.otp_uuid = otp_uuid
       new TicketService(ticket.url).verify_delivery_otp(values)
          .then((response) => {
           onOTPVerificationSuccess(response)
           dispatch(showSuccessToast('Success',
                                  'OTP has been verified successfully.'))
          })
          .catch((error) => {

          })
  }

    return (  <Slider  sliderWidth={"75vw"}
                title={
                  <>
                    <span className="pe-3">{ICONS.SMS} </span>
                    <span className="pe-3">Verify Delivery OTP</span>
                  </>
                }
                 size={"sm"}
                header={
                  <>
                    <span className="pe-3">{ICONS.SMS} </span>
                    <span className="pe-3">Verify Delivery OTP</span>
                  </>
                }
              >
                    <h2>Select the Method  to send OTP </h2>
                 <OTPReceiverForm
                    submitText={"Send OTP to Customer"}
                    contactNumbers={[{
                        "name":ticket.customer.contact_number
                    },{ "name":ticket.customer.email}]}
                    onSubmit={(val) => {
                        console.log(val)
                      new TicketService(ticket.url).send_delivery_otp({
                          delivery_otp_destination:val.otp_receiver
                      }).then((res)=>{
                          console.log(res)
                          setOTP_UUID(res.otp_uuid)
                          dispatch(showSuccessToast('Success',
                              'OTP has been sent to customer.'))
                      })
                      setStep(step + 1)
                    }}
                  />
        { (step>0 || ticket.has_valid_delivery_otp) &&  <ReactBootstrap.Alert variant={'success'}>
          <p>OTP has been sent to the customer..</p>
        </ReactBootstrap.Alert>}
                    {(step>0 || ticket.has_valid_delivery_otp) && <OTPSubmitForm  onSubmit={verifyOTPHandler}/>}

  </Slider>);
}
